import {Validators} from '@angular/forms';
import {Guid} from 'guid-typescript';

export interface IEstabProfissional {
    id?: string;
    cns: string;
    cpf: string;
    nome: string;
    nomeSocial?: string;
    registrosOcupacoes?: ICboProfissional[];
    residente: string;
    responsavelAdministrativo: string;
    responsavelTecnico: string;
    cbo?: any;
    cbosVinculados?: ICboProfissional[];
}

export interface ICboProfissional {
    cargaHorariaSemanal?: string;
    cnpjEmpregador?: string;
    codigoCbo: string;
    codigoConselho: string;
    codigoNaturezaJuridica?: string;
    id?: string;
    idFormaContratacaoDetalhamento?: string;
    registroConselho: string;
    ufConselho: string;
    conselho?: string;
    chs_total?: string;
    cbo?: string;
}

export class EstabProfissionalModel {
    id: string;
    cpf: string;
    cns: string;
    nome: string;
    cbo: string;
    responsavelAdministrativo: string;
    responsavelTecnico: string;
    residente: string;
    cbosVinculados: ICboProfissional[];

    constructor(obj?: IEstabProfissional) {
        if (obj) {
            this.id = obj.id ? obj.id : Guid.create().toString();
            this.cns = obj.cns ? obj.cns : '';
            this.cpf = obj.cpf ? obj.cpf : '';
            this.nome = obj.nome ? obj.nome : '';
            this.responsavelAdministrativo = obj.responsavelAdministrativo ? obj.responsavelAdministrativo : '';
            this.responsavelTecnico = obj.responsavelTecnico ? obj.responsavelTecnico : '';
            this.residente = obj.residente ? obj.residente : '';
            this.cbosVinculados = [];
        }
    }
}
